/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs */

const en_guide_json_vs_yaml_xml_faq_a2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON is typically the fastest to parse because of its simple syntax and widespread optimization. YAML parsers are generally slower due to the complex grammar. XML parsing speed varies but is usually between JSON and YAML.`)
};

const ko_guide_json_vs_yaml_xml_faq_a2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 단순한 구문과 광범위한 최적화 덕분에 일반적으로 가장 빠르게 파싱됩니다. YAML 파서는 복잡한 문법으로 인해 일반적으로 더 느립니다. XML 파싱 속도는 다양하지만 보통 JSON과 YAML 사이에 위치합니다.`)
};

const ja_guide_json_vs_yaml_xml_faq_a2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONは通常、シンプルな構文と広範な最適化のおかげで、最も速くパースできます。YAMLパーサーは複雑な文法のため一般的に遅くなります。XMLのパース速度はさまざまですが、通常はJSONとYAMLの中間です。`)
};

/**
* | output |
* | --- |
* | "JSON is typically the fastest to parse because of its simple syntax and widespread optimization. YAML parsers are generally slower due to the complex grammar..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_a2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_a2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_a2(inputs)
	return ja_guide_json_vs_yaml_xml_faq_a2(inputs)
});